var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({attrs:{"outlined":"","value":_vm.currentValue,"messages":[_vm.error],"error":!!_vm.error},on:{"input":function($event){return _vm.updateFieldValue(_vm.name, $event)}}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }